<app-loader [isLoading]="isLoading"></app-loader>
<div class="edit-details-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="edit-details-text">Edit/Add details</span>
    <div class="img-container" mat-dialog-close>
      <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
    </div>
  </div>
  @if(data.data.length>=1){
  <div class="main-div">
    <div class="edit-div" *ngFor="let item of data.data;let i=index">
      <form [formGroup]="editDetailsForm[i]">
        @if(data.type!=='pm'){
        <div class="d-flex edit-gap column-gap">
          <div class="d-flex flex-column" style="width:100%">
            <label class="search-text">Family Code</label>
            <div class="d-flex align-items-center">
              @if(fcDetails.length>0){
              <mat-form-field class="select-mat-form-field custom-select-form" style="width:100%; margin-top: 5px;">
                <mat-select class="custom-mat-select custom-select" placeholder="Select Member"
                  formControlName="familyCode" style="width:100%">
                  <mat-option *ngFor="let item of fcDetails" [value]="item.mem_name+' '+item.mem_surname"
                    (click)="onSelectFCDropDown(item)">
                    <div class="d-flex flex-column justify-content-between">
                      <span> {{ item.mem_name }}&nbsp;&nbsp;{{ item.mem_surname }}</span>
                    </div>
                  </mat-option>
                </mat-select>
                @if(editDetailsForm[i].get('isEditable')?.value){
                <button mat-icon-button matSuffix (click)="onClearClick()" class="clear-button">
                  <mat-icon class="clear-icon">clear</mat-icon>
                </button>
                }
              </mat-form-field>}@else{
              <input class="dp-input-control update-input mt-1" placeholder="Enter 12 digit Family code"
                formControlName="familyCode" minlength="12" maxlength="12"
                [readonly]="!editDetailsForm[i].get('isEditable')?.value" />
              }
            </div>

          </div>
        </div>
        }
        <div class="d-flex edit-gap column-gap">
          <div class="d-flex flex-column">
            <label class="search-text">Contact no.</label>
            <input class="dp-input-control update-input mt-1" placeholder="Enter Contact No" formControlName="contactNo"
              minlength="10" maxlength="10" [readonly]="!editDetailsForm[i].get('isEditable')?.value" />
            <span *ngIf="
                      editDetailsForm[i].controls['contactNo'].invalid &&
                      editDetailsForm[i].controls['contactNo'].touched
                    " class="error-message mt-1">
              Please enter a valid contact no
            </span>
          </div>
          <div class="d-flex flex-column">
            <label class="search-text">Pincode</label>
            <input type="tel" class="dp-input-control mt-1" placeholder="Enter pincode" formControlName="pin"
              maxlength="6" minlength="6" [readonly]="!editDetailsForm[i].get('isEditable')?.value" />
          </div>

          <div class="state-filter">
            <label class="search-text">State</label>
            <input type="text" class="dp-input-control mt-1" placeholder="Enter pincode first" formControlName="state"
              readonly />
          </div>
          <div class="state-filter">
            <label class="search-text">District</label>
            @if(districtList.length
            <=1){ <input type="text" class="dp-input-control mt-1" placeholder="Enter pincode first"
              formControlName="district" readonly />
            }@else{
            <mat-form-field class="select-mat-form-field custom-select-form">
              <mat-select class="custom-mat-select custom-select" id="district" placeholder="Select district"
                formControlName="district">
                <mat-option *ngFor="let district of districtList" [value]="district">
                  {{ district }}
                </mat-option>
              </mat-select>
            </mat-form-field>}
          </div>
        </div>

        <div class="d-flex flex-column edit-gap">
          <label class="search-text">Landmark</label>
          <input type="text" class="dp-input-control mt-1" placeholder="Enter landmark"
            [readonly]="!editDetailsForm[i].get('isEditable')?.value" formControlName="landMark" />
          <span *ngIf="
          editDetailsForm[i].controls['landMark'].invalid &&
          editDetailsForm[i].controls['landMark'].touched
        " class="error-message mt-1">
            Please enter landmark
          </span>
        </div>
        <div class="d-flex flex-column edit-gap">
          <label class="search-text">Address</label>
          <textarea class="dp-input-control fixed-height-textarea mt-1" placeholder="Enter Address"
            formControlName="address" [readonly]="!editDetailsForm[i].get('isEditable')?.value"></textarea>
          <span *ngIf="
          editDetailsForm[i].controls['address'].invalid &&
          editDetailsForm[i].controls['address'].touched
        " class="error-message mt-1">
            Please enter a valid address
          </span>
        </div>
        @if(data.type!=='pm'){
        <div class="d-flex flex-column edit-gap">
          <label class="custom-checkbox">
            <span class="search-text">Inactive</span>
            @if(editDetailsForm[i].get('inactive')?.value!=null){
            <input type="checkbox" checked disabled />
            <span class="checkmark"></span>
            }@else{
            <input type="checkbox" (change)="onInactiveClick($event,'edit')"
              [disabled]="!editDetailsForm[i].get('isEditable')?.value" />
            <span class="checkmark"></span>
            }
          </label>
        </div>
        }
        @if(data.type==='pm'){
        <div class="d-flex flex-column edit-gap">
          <label class="search-text">Notes</label>
          <textarea class="dp-input-control fixed-height-textarea mt-1" placeholder="Enter Notes" formControlName="note"
            [readonly]="!editDetailsForm[i].get('isEditable')?.value"></textarea>
        </div>
        }
        @if(editDetailsForm[i].get('createdBy')?.value==userId && !editDetailsForm[i].get('isEditable')?.value){
        <button class="dp-primary-btn save-btn edit-gap" (click)="onClickEdit(i)">Edit</button>
        }@else if(editDetailsForm[i].get('createdBy')?.value==userId && editDetailsForm[i].get('isEditable')?.value){
        <button class="dp-primary-btn save-btn edit-gap" (click)="onEditSaveClick(i,'edit')">Save Changes</button>
        }
      </form>
    </div>
  </div>}
  @if(showDetails){
  <div class="main-div">
    <div class="edit-div">
      <form [formGroup]="addDetailsForm">
        <div class="d-flex edit-gap column-gap">
          <div class="d-flex flex-column" style="width:100%">
            <label class="search-text">Family Code</label>
            @if(fcDetails.length>0){
            <mat-form-field class="select-mat-form-field custom-select-form" style="margin-top: 5px;width:100%">
              <mat-select class="custom-mat-select custom-select" placeholder="Select Member"
                formControlName="familyCode" style="width:100%">
                <mat-option *ngFor="let item of fcDetails" [value]="item.mem_name+' '+item.mem_surname"
                  (click)="onSelectFCDropDown(item)">
                  <div class="d-flex flex-column justify-content-between">
                    <span> {{ item.mem_name }}&nbsp;&nbsp;{{ item.mem_surname }}</span>
                  </div>
                </mat-option>
              </mat-select>
              @if(addDetailsForm.get('familyCode')?.value){
              <button mat-icon-button matSuffix (click)="onClearClick()" class="clear-button">
                <mat-icon class="clear-icon">clear</mat-icon>
              </button>
              }
            </mat-form-field>}@else{
            <input class="dp-input-control update-input mt-1" placeholder="Enter 12 digit Family code"
              formControlName="familyCode" minlength="12" maxlength="12" />
            }
          </div>
        </div>
        <div class="d-flex edit-gap column-gap">
          <div class="d-flex flex-column">
            <label class="search-text">Contact no.</label>
            <input class="dp-input-control update-input mt-1" placeholder="Enter Contact No" formControlName="contactNo"
              minlength="10" maxlength="10" />
            @if(addDetailsForm.controls['contactNo'].invalid &&
            addDetailsForm.controls['contactNo'].touched){
            <span class="error-message mt-1">
              Please enter a valid contact no
            </span>
            }
          </div>


          <div class="d-flex flex-column">
            <label class="search-text">Pincode</label>
            <input type="tel" class="dp-input-control mt-1" placeholder="Enter pincode" formControlName="pin"
              maxlength="6" minlength="6" />
          </div>

          <div class="state-filter">
            <label class="search-text">State</label>
            <input type="text" class="dp-input-control mt-1" placeholder="Enter pincode first" formControlName="state"
              readonly />
          </div>
          <div class="state-filter">
            <label class="search-text">District</label>
            @if(districtList.length
            <=1){ <input type="text" class="dp-input-control mt-1" placeholder="Enter pincode first"
              formControlName="district" readonly />
            }@else{
            <mat-form-field class="select-mat-form-field custom-select-form">
              <mat-select class="custom-mat-select custom-select" id="district" placeholder="Select district"
                formControlName="district">
                <mat-option *ngFor="let district of districtList" [value]="district">
                  {{ district }}
                </mat-option>
              </mat-select>
            </mat-form-field>}
          </div>
        </div>

        <div class="d-flex flex-column edit-gap">
          <label class="search-text">Landmark</label>
          <input type="text" class="dp-input-control mt-1" placeholder="Enter landmark" formControlName="landMark" />
          <span *ngIf="
            addDetailsForm.controls['landMark'].invalid &&
            addDetailsForm.controls['landMark'].touched
          " class="error-message mt-1">
            Please enter landmark
          </span>
        </div>
        <div class="d-flex flex-column edit-gap">
          <label class="search-text">Address</label>
          <textarea class="dp-input-control fixed-height-textarea mt-1" placeholder="Enter Address"
            formControlName="address"></textarea>
          <span *ngIf="
            addDetailsForm.controls['address'].invalid &&
            addDetailsForm.controls['address'].touched
          " class="error-message mt-1">
            Please enter a valid address
          </span>
        </div>
        @if(data.type!=='pm'){
        <div class="d-flex flex-column edit-gap">
          <label class="custom-checkbox">
            <span class="search-text">Inactive</span>
            <input type="checkbox" [checked]="this.addDetailsForm.get('inactive')?.value"
              (change)="onInactiveClick($event,'add')" formControlName="inactive" />
            <span class="checkmark"></span>
          </label>
        </div>
        }
        @if(data.type==='pm'){
        <div class="d-flex flex-column edit-gap">
          <label class="search-text">Notes</label>
          <textarea class="dp-input-control fixed-height-textarea mt-1" placeholder="Enter Notes"
            formControlName="note"></textarea>
        </div>
        }
        <button class="dp-primary-btn save-btn edit-gap" (click)="onEditSaveClick(0,'add')">Save Changes</button>

      </form>
    </div>
  </div>
  }

  @if(addDetails && !showDetails){
  <button class="dp-primary-btn save-btn edit-gap" (click)="onAddClick()">Add New Details</button>
  }


</div>